import { render, staticRenderFns } from "./main.vue?vue&type=template&id=59a4a40f&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a4a40f')) {
      api.createRecord('59a4a40f', component.options)
    } else {
      api.reload('59a4a40f', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=59a4a40f&", function () {
      api.rerender('59a4a40f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/card/src/main.vue"
export default component.exports